import {createArticlesRepository} from '../repository/massmedia/articles';
import {createEventsRepository} from '../repository/massmedia/events';
import {createNewsRepository} from '../repository/massmedia/news';
import {createPressRepository} from '../repository/massmedia/press';

import {createReferenceDataRepository} from '../repository/reference-data';
import {createCurrencyRatesRepository} from '../repository/currency-rates';
import {createCoinsRepository} from '../repository/coins';
import {createLegalLoanRepository} from '../repository/legal/loan';

import {createDebetCardsRepository} from '../repository/individual/debet-cards';
import {createCreditCardsRepository} from '../repository/individual/credit-cards';
import {createStudentCardsRepository} from '../repository/individual/student-cards';

import {createTaxDeductionFormRepository} from '../repository/forms/tax-deduction';
import {createDebetCardsFormRepository} from '../repository/forms/debet-cards';
import {createAcquiringFormRepository} from '../repository/forms/acquiring';
import {createIndividualPaymentFormRepository} from '../repository/forms/individual-payment';
import {createOnlineCashboxFreeFormRepository} from '../repository/forms/online-cashbox';
import {createBankAgreementSignBkiFormRepository} from '../repository/forms/bank-agreement-sign-bki';
import {createBankGuaranteesFormRepository} from '../repository/forms/bank-guarantees';
import {createCallbackFormRepository} from '../repository/forms/callback';
import {createFeedbackFormRepository} from '../repository/forms/feedback';
import {createSalaryProjectFormRepository} from '../repository/forms/salary-projects';
import {createSupportMeasuresFormRepository} from '../repository/forms/support-measures';
import {createBankAgreementFormRepository} from '../repository/forms/bank-agreement';

import {createIndividualDepositCalcRepository} from '../repository/calculators/individual-deposit';
import {createLegalDepositCalcRepository} from '../repository/calculators/legal-deposit';
import {createIndividualCreditCalcRepository} from '../repository/calculators/individual-credit';

import {createElasticSearchRepository} from '../repository/common/elastic-search';
import {createMenuRepository} from '../repository/common/menu';
import {createChatStatusRepository} from '../repository/common/chat-status';
import {createCarChargingRepository} from '../repository/common/car-charging';
import {createFingerprintRepository} from '../repository/common/fingerprint';
import {createEsiaRepository} from '../repository/common/esia';
import {createLeadsRepository} from '../repository/common/leads';
import {createPostbackRepository} from '../repository/common/postback';

import CONSTANTS from '@/core/constants';

export default ({$axios, $config}, inject) => {
    const bankApi = $axios.create({
        baseURL: $config.baseUrl,
    });
    const cabinetApi = $axios.create({
        baseURL: $config.baseCabinetUrl,
    });

    const api = {
        referenceData: createReferenceDataRepository(bankApi),
        rates: createCurrencyRatesRepository(bankApi),
        coins: createCoinsRepository(bankApi),
        forms: {
            taxDeduction: createTaxDeductionFormRepository(cabinetApi),
            debetCards: createDebetCardsFormRepository(cabinetApi),
            acquiring: createAcquiringFormRepository(cabinetApi),
            individualPayment: createIndividualPaymentFormRepository(cabinetApi),
            onlinecashbox: createOnlineCashboxFreeFormRepository(cabinetApi),
            signBki: createBankAgreementSignBkiFormRepository(cabinetApi),
            bankGuarantees: createBankGuaranteesFormRepository(cabinetApi),
            callback: createCallbackFormRepository(bankApi),
            feedback: createFeedbackFormRepository(cabinetApi),
            salaryProject: createSalaryProjectFormRepository(cabinetApi),
            supportMeasures: createSupportMeasuresFormRepository(cabinetApi),
            bankAgreement: createBankAgreementFormRepository(cabinetApi),
        },
        massmedia: {
            articles: createArticlesRepository(bankApi),
            news: createNewsRepository(bankApi),
            press: createPressRepository(bankApi),
            events: createEventsRepository(bankApi),
        },
        legal: {
            loan: createLegalLoanRepository(bankApi),
        },
        individual: {
            debetCards: createDebetCardsRepository(bankApi),
            creditCards: createCreditCardsRepository(bankApi),
            studentCards: createStudentCardsRepository(bankApi),
        },
        calculators: {
            individualDeposit: createIndividualDepositCalcRepository(bankApi),
            legalDeposit: createLegalDepositCalcRepository(bankApi),
            individualCredit: createIndividualCreditCalcRepository(bankApi),
        },
        common: {
            menu: createMenuRepository($axios),
            elastic: createElasticSearchRepository(bankApi),
            fingerprint: createFingerprintRepository(cabinetApi),
            esia: createEsiaRepository(cabinetApi),
            leads: createLeadsRepository(cabinetApi),
            chatStatus: createChatStatusRepository($axios.create({
                baseURL: 'https://www.centrinvest.ru/',
            })),
            carCharging: createCarChargingRepository($axios.create({
                baseURL: $config.electroStations,
            })),
            postBack: createPostbackRepository($axios),
        },
    };

    inject('api', api);
    inject('requestBankApi', bankApi);
    inject('requestCabinetApi', cabinetApi);
    inject('CONSTANTS', CONSTANTS);
};
